<script setup lang="ts">
import { nextTick, Transition, watch } from "vue";

const props = defineProps<{
	visible: boolean;
}>();

const emit = defineEmits<(e: "update:visible", value: boolean) => void>();

const hidePopupWindowDefault = () => {
	emit("update:visible", false);
};

watch(
	() => props.visible,
	async (newValue) => {
		if (newValue) {
			await nextTick();
		}
		(props as any).isVisible = newValue;
	},
);
</script>

<template>
	<Transition name="popupWindowDefaultBlack" appear @after-leave="() => { emit('update:visible', false) }">
		<div v-if="props.visible" class="background_black" @click="hidePopupWindowDefault"></div>
	</Transition>
	<Transition name="popupWindowDefault" appear @after-leave="() => { emit('update:visible', false) }">
		<div v-if="props.visible" class="popupWindowDefault_overlay">
			<slot />
		</div>
	</Transition>
</template>

<style lang="scss" scoped>
  @use './popupWindowDefault.scss';
</style>
